import i18n from 'i18next';
import dayjs from "dayjs";
import "dayjs/locale/zh-cn"; // 필요한 언어팩 로드
import "dayjs/locale/ko";
import "dayjs/locale/en";
import { initReactI18next } from 'react-i18next';
import translationEN from "locales/en/translation.json";
import translationKO from "locales/ko/translation.json";
import translationZHCN from "locales/zh-cn/translation.json";
import { syncDayjsLocale } from 'components/date_picker/dateUtils';

const resources = {
  en: {
    translation: translationEN,
  },
  ko: {
    translation: translationKO,
  },
  'zh-CN': {
    translation: translationZHCN,
  },
};

// 1. 현재 환경 변수에 설정된 기본 언어 가져오기
const envLang = process.env.REACT_APP_LANGUAGE || 'ko';

// 2. 로컬 스토리지에 저장된 이전 환경 변수 값 확인 (비교용)
const savedLang = localStorage.getItem("lang");
const lastEnvLang = localStorage.getItem("last_env_lang");

let initialLang = savedLang || envLang;

// 3. 환경 변수가 이전에 저장한 값과 다르다면? (즉, .env가 수정되었다면)
if (envLang !== lastEnvLang) {
  initialLang = envLang;
  localStorage.setItem("lang", envLang);        // 실제 사용 언어 갱신
  localStorage.setItem("last_env_lang", envLang); // 현재 환경 변수 상태 기록
} else {
  // .env가 그대로라면 dayjs에도 저장된 언어 적용
  dayjs.locale(initialLang.toLowerCase());
}

// 4. 최종적으로 결정된 언어 사용
// const currentLang = localStorage.getItem("lang") || envLang;

i18n
  .use(initReactI18next) // 리액트에 i18next를 연결합니다.
  .init({
    resources,
    lng: localStorage.getItem("lang") || process.env.REACT_APP_LANGUAGE , // 기본 언어 설정
    fallbackLng: 'ko', // 언어가 지원되지 않을 때의 대체 언어 설정
    interpolation: {
      escapeValue: false, // 리액트는 HTML 태그도 렌더링할 수 있어서 false로 설정합니다.
    },
  })
  .then(() => {
    // ⭐ 핵심: 초기화가 끝난 직후, 현재 결정된 언어를 dayjs에 강제로 먹입니다.
    // const currentLang = i18n.language.toLowerCase();
    // dayjs.locale(currentLang);
    syncDayjsLocale(i18n.language);
    // console.log("초기 로딩 Dayjs locale:", dayjs.locale());
});

i18n.on("languageChanged", (lng) => {
  syncDayjsLocale(lng);
  // if (lng === "ko") dayjs.locale("ko");
  // else if (lng === "zh") dayjs.locale("zh-cn");
  // else dayjs.locale("en");
});

export default i18n;